import * as React from 'react';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { Link } from 'react-router-dom';

// COMPONENTS
import AccountMenu from '../AccountMenu';

// ICONS
import { ReactComponent as MainLogo } from '../../assets/img/logo-main.svg';

// TYPES
interface propsType {
	children: React.ReactNode;
	className?: string;
}

const LayoutOneColumn: React.FC<propsType> = ({ children, className = '' }) => {
	// Check if the user is logged in
	const isLoggedIn = useAppSelector(({ user }) => user.loggedIn);

	// Get website url from Redux store
	const websiteUrl = useAppSelector((state) => state.lists.websiteUrl);

	return (
		<>
			<main className={'layout-one-column ' + className}>
				<header className="standalone-header">
					<div className="header-gradient"></div>

					<div className="header-content">
						{isLoggedIn ? (
							<Link to="/">
								<MainLogo />
							</Link>
						) : (
							<a href={websiteUrl} className="logo">
								<MainLogo />
							</a>
						)}

						<AccountMenu />
					</div>
				</header>

				<div className="page">{children}</div>
			</main>
		</>
	);
};

export default LayoutOneColumn;
